import {
  Component, OnInit, OnDestroy, AfterViewInit, ChangeDetectorRef,
  Output, EventEmitter
} from '@angular/core';
import { ApiHandlerService } from '../../../core/api-handlers';
import { AppGlobal } from '../../../app.global';
import { HttpErrorResponse } from '@angular/common/http';
import { untilDestroyed } from '../../../core/services';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ToastsService } from '../../../core/services/toasts.service';
import { SubSink } from 'subsink';
import { UtilityService } from '../../../core/services/utility.service';
import { Router } from '@angular/router';
import { HomeService } from '../../../modules/home/home.service';
import { MatDialog } from '@angular/material/dialog';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { SwalService } from '../../../core/services/swal.service';

declare var $: any;
@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit, AfterViewInit, OnDestroy {
  @Output() Navigate = new EventEmitter();

  private subSunk = new SubSink();
  regConfig: FormGroup;
  submitted: boolean = false;
  domainInfo: any;
  dataLoaded: Promise<boolean>;
  footerList:any=[];
  socialLink: any;
  showPaymentDetails: boolean = false;
  contactForm: FormGroup;
  protected subs = new SubSink();
  domainData:any;
  currentYear: number;
  constructor(
    private apiHandlerService: ApiHandlerService,
    public globals: AppGlobal,
    private fb: FormBuilder,
    private util: UtilityService,
    private toastService: ToastsService,
    private router: Router,
    private changeDetector: ChangeDetectorRef,
    private homeService: HomeService,
    public dialog: MatDialog,
    private swalService: SwalService,
  ) { }

  ngOnInit() {
    this.currentYear = new Date().getFullYear();
    this.getSocialLink();
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
    //this.getDomainInfoList();
    //this.getDomainLogo();
    this.createForm();
    this.createContactForm();
    this.getStaticList();
    this.manageDomain();
  }

  getSocialLink() {
    this.apiHandlerService.apiHandler('socialLink', 'post', {}, {}, {})
      .subscribe(resp => {
        if ((resp.statusCode == 200 || resp.statusCode == 201)) {
          if (resp.data) {
            this.socialLink = resp.data.filter(link => link.status === "1");
          } else {
            this.socialLink = []; 
          }
        }
      }, (err: HttpErrorResponse) => {
        console.error(err.error);
      });
  }
  


  setTheme(themeName) {
    localStorage.setItem('theme', themeName);
    document.documentElement.className = themeName;
  }
  toggleTheme() {
    if (localStorage.getItem('theme') === 'theme-dark') {
      this.setTheme('theme-light');
    } else {
      this.setTheme('theme-dark');
    }
  }

  ngAfterViewInit(): void {
  }

  staticPagesList: Array<any> = [];
  modulesList: Array<any> = [];
  getStaticList() {
    this.subSunk.sink = this.apiHandlerService.apiHandler('staticPageContentList', 'post', {}, {}, {})
      .subscribe(resp => {
        if (resp && resp.data) {
          this.footerList=resp.data.filter(a => a.module.toLowerCase()=='footer')
          let result = resp.data
            .filter(a => a.module.toLowerCase()!='footer')
            .map(a => a.module);
          this.modulesList = [...new Set(result)];
          this.staticPagesList = resp.data;
          this.changeDetector.detectChanges();
        }
      })
  }

  getDomainLogo() {
    this.apiHandlerService.apiHandler('domainLogo', 'post', {}, {}, { type: 'footer' })
      .pipe(untilDestroyed(this))
      .subscribe(resp => {
        if (resp.Status && resp.Data) {
          this.globals.logoFooter = resp.Data.domain_logo;
        }
      }, (err: HttpErrorResponse) => {
        console.error(err.error);
      })
  }

  getDomainInfoList() {
    this.apiHandlerService.apiHandler('domainInformationList', 'post', {}, {}, {})
      .pipe(untilDestroyed(this))
      .subscribe(resp => {
        if (resp.statusCode == 200 && resp.data) {
          this.domainInfo = resp.data[0];
          this.dataLoaded = Promise.resolve(true);
        }
      }, (err: HttpErrorResponse) => {
        console.error(err.error);
      })

  }

  onPageSelect(page) {
    if (page.page_title == "Flights" || page.page_title == "Hotels" || page.page_title == "Activity" || page.page_title == "Transfers" || page.page_title=='Flights Plus Hotels' || page.page_title=='Holiday') {
      if (this.router.url !== "/") {
        this.router.navigate([""]);
      }     
       this.homeService.footerSearchTab.next(page.page_title)
      return;
    }
    else if (page.page_title == 'B2C Supplier Login') {
      window.open('https://booking247.com/supplier/#/auth/login', '_blank');
    }
    else if (page.page_title == 'Travel Agent Login') {
      window.open('https://booking247.com/b2b/#/auth/login', '_blank');
    }
    else {
      sessionStorage.setItem('static_title', page.page_title);
     const url = this.router.serializeUrl(
      this.router.createUrlTree([page.page_redirection_url])
    );
    window.open(url, '_blank')
    }
   
  }
  onPartnerSelect() {
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/faq/faq-question'])
  );
 window.open(url, '_blank');
  }
  onCustomerSelect(){
    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/faq/customer-faq'])
  );
 window.open(url, '_blank');
  } 
  createForm() {
    this.regConfig = this.fb.group({
      email_id: new FormControl('', [Validators.required, Validators.minLength(5), Validators.maxLength(30), Validators.pattern('^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$')]),

    });
  }

  hasError = (controlName: string, errorName: string) => {
    return ((this.submitted || this.regConfig.controls[controlName].touched) && this.regConfig.controls[controlName].hasError(errorName));
  }
  contactHasError = (controlName: string, errorName: string) => {
    return ((this.submitted || this.contactForm.controls[controlName].touched) && this.contactForm.controls[controlName].hasError(errorName));
  }

  onSubmit() {
    this.submitted = true;
    if (!this.regConfig.valid) {
      return;
    }
    let req = this.regConfig.value;
    req['subscription_type'] = "newsletter";
    req['module'] = "";

    this.apiHandlerService.apiHandler('addEmailSubscription', 'post', {}, {}, req)
      .subscribe(resp => {

        if(resp.statusCode == 200 && resp.data == "EmailID Already Exists for the subscription type"){
          this.toastService.toast({ 'type': 'error', 'text': 'EmailID Already Exists for the subscription type"..' });
        }else if ((resp.statusCode == 200 || resp.statusCode == 201) &&  (resp.data !== "EmailID Already Exists for the subscription type")) {
          this.toastService.toast({ 'text': 'Thanks for subscriptions..', 'type': 'success' });
          this.submitted = false;
          this.regConfig.reset();
        } else {
          this.toastService.toast({ 'type': 'error', 'text': 'Something went wrong..' });
        }

      },(err =>{
        this.toastService.toast({ 'type': 'error', 'text': 'Something went wrong..' });
      }))

  }
  onContact(t: any) {
    this.submitted =true;
    if (t.invalid) {
        return;
    } else {
        const formdata = {
            first_name: this.contactForm.controls['first_name'].value,
            last_name: this.contactForm.controls['last_name'].value,
            contact_no: this.contactForm.controls['contact_no'].value,
            contact_email: this.contactForm.controls['contact_email'].value,
            description: this.contactForm.controls['inquiry_text'].value,

        }
        const formdata1 = JSON.stringify(formdata)
        
        this.subs.sink = this.apiHandlerService.apiHandler('AddContactList', 'POST', '', '', { ...formdata })
            .subscribe(res => {

                if (res.Status == true) {
                    this.swalService.alert.success('Contact Added successfully');
                    this.showPaymentDetails = false;
                    this.contactForm.reset();
                    this.router.navigate(['/']);

              } else {
                    // this.hide = true;
                    // this.errorMessage = res.data.msg;
                    this.swalService.alert.oops(res.Message);
                }
            }, (errorResponse) => {
                // this.hide = true;
                if (errorResponse.error.Message == "403 Already exists") {
                    this.swalService.alert.oops("Email Already Exists.");
                }else{
                    this.swalService.alert.oops(errorResponse.error.msg);
                }
            });
    }
}

createContactForm() {
  this.contactForm = this.fb.group({
      first_name: ['', [Validators.required]],
      last_name: ['', [Validators.required]],   
      contact_no: ['', [Validators.required, Validators.pattern(this.util.regExp.phoneNo)]],
      contact_email: ['', [Validators.required, Validators.pattern(this.util.regExp.email),]],
      inquiry_text:['',],
 
  });
}
numberOnly(event): boolean {
  const charCode = (event.which) ? event.which : event.keyCode;
  if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
  }
  return true;

}
omitSpecialCharacters(event) {
  let k = event.charCode;
  return ((k > 64 && k < 91) || (k > 96 && k < 123) || k == 8 || k == 32);
}
openContactDialog(){
  this.showPaymentDetails = true;

}
manageDomain() {
  this.apiHandlerService.apiHandler('adminManageDomain', 'post', {}, {}, { type: 'header' })
      .pipe(untilDestroyed(this))
      .subscribe(resp => {
    
          if (resp.Status && resp.data) {
              this.domainData = resp.data[0];
        
          }
      }, (err: HttpErrorResponse) => {
  
      })
}
  ngOnDestroy() { }

}
